import * as React from 'react'
import isBrowser from '../../../services/isBrowser';

export const useStickyHeader = (headerRef, isHover) => {

    const [scrollState, setScrollState] = React.useState({lastScroll: 0, showHeader: true, showFadedEdge: true});
    
    const innerHandler = () => {
        if (!isBrowser()) return;
        const height = headerRef?.current?.offsetHeight;
        let currentScroll = document?.documentElement?.scrollTop;
        const newState = { ...scrollState };
        if ((currentScroll > scrollState.lastScroll) && (currentScroll > height) && !isHover) {
            newState.showHeader = false
        }
        else {
            newState.showHeader = true
        }
        if (currentScroll > height * 1.2) {
            newState.showFadedEdge = false;
        }
        else {
            newState.showFadedEdge = true;
        }
        newState.lastScroll = currentScroll;
        setScrollState(newState);
    }

    React.useEffect(() => {
        
        if (isBrowser()) {
            document.addEventListener('scroll', innerHandler)
        }
        return () => {
            if (isBrowser()) {
                document.removeEventListener('scroll', innerHandler)
            }
        }

    });
    return { ...scrollState };



}